import { getPermissionValueAtPath } from "../../../components/PermissionGate/PermissionGate.tsx"
import { type ProductTourStep } from "../tour/product-tour.types.ts"
import { PRODUCT_TOUR } from "./product-tour-steps.ts"

/**
 * `requiredPage` is either a bare page code ("leads", "projects" — checked
 * against `permissions.pages`, same as the rest of the Guide) or a
 * `category.section.key` dot-path ("projects.milestones.project_milestone_view")
 * resolved via `getPermissionValueAtPath` — the same traversal `PermissionGate`
 * itself uses against `permissions.codes`, so a step's gate is never a
 * second, invented permission model.
 */
export const isProductTourStepPermitted = (
  requiredPage: string | undefined,
  pages: readonly string[] | null | undefined,
  codes: unknown
): boolean => {
  if (!requiredPage) return true
  if (!requiredPage.includes(".")) return (pages ?? []).includes(requiredPage)

  return getPermissionValueAtPath(codes, requiredPage)
}

/** Filtered once, when the tour starts — a step the user has no permission
 * for is simply never part of their tour, not something skipped mid-run. */
export const visibleProductTourSteps = (
  pages: readonly string[] | null | undefined,
  codes: unknown
): ProductTourStep[] =>
  PRODUCT_TOUR.steps.filter((step) =>
    isProductTourStepPermitted(step.requiredPage, pages, codes)
  )
